/* src/config/constants/actionTypes.js */

/* localstore */
export const SAVE_ADMIN_TOKEN = 'SAVE_ADMIN_TOKEN';
export const SAVE_ADMIN_TOKEN_FAIL = 'SAVE_ADMIN_TOKEN_FAIL';
export const GET_ADMIN_TOKEN = 'GET_ADMIN_TOKEN';
export const GET_ADMIN_TOKEN_FAIL = 'GET_ADMIN_TOKEN_FAIL';

/* auth */
export const LOGIN = 'LOGIN';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_AFTER_LOGIN = 'FETCH_USER_AFTER_LOGIN';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAIL = 'FETCH_USER_FAIL';
export const LOG_OUT = 'LOG_OUT';

/* courses */
export const FETCH_COURSES = 'FETCH_COURSES';
export const FETCH_COURSES_SUCCESS = 'FETCH_COURSES_SUCCESS';
export const FETCH_COURSES_FAIL = 'FETCH_COURSES_FAIL';
export const FETCH_COURSE = 'FETCH_COURSE';
export const FETCH_COURSE_SUCCESS = 'FETCH_COURSE_SUCCESS';
export const FETCH_COURSE_FAIL = 'FETCH_COURSE_FAIL';

/* course approvals */
export const FETCH_COURSE_APPROVALS = 'FETCH_COURSE_APPROVALS';
export const FETCH_COURSE_APPROVALS_SUCCESS = 'FETCH_COURSE_APPROVALS_SUCCESS';
export const FETCH_COURSE_APPROVALS_FAIL = 'FETCH_COURSE_APPROVALS_FAIL';
export const SELECT_COURSE_APPROVAL = 'SELECT_COURSE_APPROVAL';
export const MODIFY_COURSE_APPROVAL = 'MODIFY_COURSE_APPROVAL';
export const MODIFY_COURSE_APPROVAL_SUCCESS = 'MODIFY_COURSE_APPROVAL_SUCCESS';
export const MODIFY_COURSE_APPROVAL_FAIL = 'MODIFY_COURSE_APPROVAL_FAIL';

/* interviews */
export const FETCH_APPLICANTS = 'FETCH_APPLICANTS';
export const FETCH_APPLICANTS_SUCCESS = 'FETCH_APPLICANTS_SUCCESS';
export const FETCH_APPLICANTS_FAIL = 'FETCH_APPLICANTS_FAIL';

/* lessons */
export const FETCH_LESSONS = 'FETCH_LESSONS';
export const FETCH_LESSONS_SUCCESS = 'FETCH_LESSONS_SUCCESS';
export const FETCH_LESSONS_FAIL = 'FETCH_LESSONS_FAIL';
export const FETCH_LESSON = 'FETCH_LESSON';
export const FETCH_LESSON_SUCCESS = 'FETCH_LESSON_SUCCESS';
export const FETCH_LESSON_FAIL = 'FETCH_LESSON_FAIL';

/* locations */
export const FETCH_LOCATIONS = 'FETCH_LOCATIONS';
export const FETCH_LOCATIONS_SUCCESS = 'FETCH_LOCATIONS_SUCCESS';
export const FETCH_LOCATIONS_FAIL = 'FETCH_LOCATIONS_FAIL';

/* students */
export const FETCH_STUDENTS = 'FETCH_STUDENTS';
export const FETCH_STUDENTS_SUCCESS = 'FETCH_STUDENTS_SUCCESS';
export const FETCH_STUDENTS_FAIL = 'FETCH_STUDENTS_FAIL';
export const FETCH_STUDENT = 'FETCH_STUDENT';
export const FETCH_STUDENT_SUCCESS = 'FETCH_STUDENT_SUCCESS';
export const FETCH_STUDENT_FAIL = 'FETCH_STUDENT_FAIL';

/* tutors */
export const FETCH_TUTORS = 'FETCH_TUTORS';
export const FETCH_TUTORS_SUCCESS = 'FETCH_TUTORS_SUCCESS';
export const FETCH_TUTORS_FAIL = 'FETCH_TUTORS_FAIL';
export const FETCH_TUTOR = 'FETCH_TUTOR';
export const FETCH_TUTOR_SUCCESS = 'FETCH_TUTOR_SUCCESS';
export const FETCH_TUTOR_FAIL = 'FETCH_TUTOR_FAIL';

/* universities */
export const FETCH_UNIVERSITIES = 'FETCH_UNIVERSITIES';
export const FETCH_UNIVERSITIES_SUCCESS = 'FETCH_UNIVERSITIES_SUCCESS';
export const FETCH_UNIVERSITIES_FAIL = 'FETCH_UNIVERSITIES_FAIL';



// WEBPACK FOOTER //
// ./src/config/constants/actionTypes.js